
const saleCommonUtility = require('../../../../../utils/domain/sales/saleCommonUtility');
const salePublisher = require('../../../../../utils/domain/sales/salePublisher');
const saleInitializer = require('../../../../../utils/domain/sales/saleInitializer');
const saleCalculator = require('../../../../../utils/domain/sales/saleCalculator');
const constants = require('../../../../../utils/domain/constants.js');
const stringUtil = require('../../../../../utils/string/stringUtil.js');
const dateUtil = require('../../../../../utils/dateUtil/dateUtil');
const guidUtil = require('../../../../../utils/guid/guidUtil');
const stateManager = require('../../../../../utils/state/stateManager');
const salesLoader = require('../../../../../utils/domain/sales/salesLoader');
const jobsServer = require('../../../../../utils/jobs/jobsServer');
const rmsApiProxyRetry = require('../../../../../utils/api/rmsApiProxyRetry');
const todaysSalesUpdatedDateTimeAction = require('../../../../../utils/state/actions/sales/todaysSalesUpdatedDateTimeAction');


export function updateSaleAsPaidInFullByCash(sale)
{
    const balanceAmount = saleCalculator.calculateRemainingPayableAmount(sale);

    if (balanceAmount < constants.numericThresholdValue)
        return;

    sale.lastUpdatedDateTime = dateUtil.getNow();    
    sale.paidAmount = balanceAmount;
    sale.receiptLines.push(saleInitializer.createReceiptLine(constants.ReceiptLineTypeCharge, sale.paidAmount, constants.PaymentMethodCash));
    sale.paymentMethod = sale.receiptLines.some(receiptLine => JSON.parse(receiptLine.line).mode !== constants.PaymentMethodCash)
        ? constants.PaymentMethodMix
        : constants.PaymentMethodCash;


    salePublisher.publishSaleInChannel(sale);

    jobsServer.addJob(
        guidUtil.generateGuid(),
        "Sales.Publishing",
        async () => rmsApiProxyRetry.post(`${rmsApiProxyRetry.getOrgContextToUrl()}/accounts/sales`, sale)
    );

    if (saleCommonUtility.isTodaysBusinessDateSale(sale))
    {
        salesLoader.initializeSale(sale);

        const todaySales = stateManager.getStore().getState().todaySales.filter(s => !stringUtil.areStringSame(s.id, sale.id));
        todaySales.push(sale);
        stateManager.getStore().getState().todaySales = todaySales;

        stateManager.getStore().dispatch(todaysSalesUpdatedDateTimeAction.createAction());
    }

    return sale;
}